import { progressiveComponent } from 'site-modules/shared/components/progressive-component/progressive-component';

export const PricingCarouselProgressive = progressiveComponent({
  fullComponent: {
    loader: () =>
      import(
        /* webpackChunkName: "pricing-carousel" */ 'site-modules/shared/components/core-page/pricing-carousel/pricing-carousel'
      ),
    name: 'PricingCarousel',
  },
});
